// Web Push: register the service worker, ask permission, subscribe, and send the
// subscription to the backend. Enables notifications when the app is closed / phone locked.
import { api } from "./api";

function urlB64ToUint8(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return typeof navigator !== "undefined" && "serviceWorker" in navigator &&
    typeof window !== "undefined" && "PushManager" in window && "Notification" in window;
}

export function pushPermission() {
  try { return Notification.permission; } catch { return "default"; }
}

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try { return await navigator.serviceWorker.register("/sw.js"); }
  catch { return null; }
}

// Full opt-in flow (call from a user click). Throws a code on failure.
export async function enablePush() {
  if (!pushSupported()) throw new Error("not-supported");
  const reg = await registerSW();
  if (!reg) throw new Error("no-sw");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const { data } = await api.get("/push/vapid-public");
  if (!data.key) throw new Error("no-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8(data.key),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

// Silent: if already granted, make sure SW is registered & subscription is on file.
export async function ensurePushIfGranted() {
  try {
    if (!pushSupported() || pushPermission() !== "granted") return;
    await enablePush();
  } catch { /* ignore */ }
}
